import { InjectionToken } from '@angular/core';
import storage from 'local-storage-fallback';

export const STORAGE_TOKEN = new InjectionToken<Storage | StorageFallback>(
  'STORAGE_TOKEN',
  {
    factory: (): typeof storage => storage,
  }
);
